import styles from "./styles.module.scss";
import { content } from "@/pages/Home/ui/HowItWorks/ui/Steps/content";
import { Typography } from "@/shared/ui/Typography";
import { BRAND_TEXT_PRIMARY, BRAND_TEXT_SECONDARY } from "@/styles/colorsJS";
import { twCn } from "@/styles/utils";

export const Steps = () => (
  <div className={twCn(styles.moneyStepsWrapper, "lgc:mt-15 mt-14")}>
    {content.map(({ order, Icon, title, description }, index) => (
      <div key={index} className={styles.item}>
        <div className={styles.decor}>{order}</div>
        <div className={styles.titleWrapper}>
          <Icon />
          <Typography as="h3" type="title" color={BRAND_TEXT_PRIMARY}>
            {title}
          </Typography>
        </div>
        <Typography as="p" color={BRAND_TEXT_SECONDARY}>
          {description}
        </Typography>
      </div>
    ))}
  </div>
);
